import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-modular-cabinet-features',
    templateUrl: './modular-cabinet-features.component.html',
    styleUrls: ['./modular-cabinet-features.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class ModularCabinetFeaturesComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  cabinetInsulationSelection!: GuruEntity;
  riserChaseSelection!: GuruEntity;
  drainPanSelection!: GuruEntity;
  cabinetUpsizingSelection!: GuruEntity;
  coilWrapperSelection!: GuruEntity;
  cabinetHeightSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.CABINET_FEATURES;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.cabinetInsulationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabinetInsulation');
    this.riserChaseSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRiserChase');
    this.drainPanSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USDrainPan');
    this.cabinetUpsizingSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabinetFootprint');
    this.coilWrapperSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCoilEndSheet');
    this.cabinetHeightSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabinetHeight');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
